export class FacilityConfiguration {
    facilityConfigurationId: string;
    facilityId: string;
    passwordExpiryInterval: number;
    loginExpiration: number;
    minPasswordLength: number;
    enableSchedules: boolean;
    enableQuestionnarie: boolean;
    emrvendorId: string;
    emrvendorCode: string;
    offeringId: string;
    allowIp: boolean;
    allowIprange: boolean;
    enableBreachWarningMsgUnit: boolean;
    enableRecentlyLoggedOnUnit: boolean;
    simpleObserverReport: boolean;
    allowHoldingVitals: boolean;
    holdBreachOnly: boolean;
    maxPasswordLength: number;
    isMixedCaseRequired : boolean;
    minSpecialCharacters: number;
    minNumericCharacters: number;
    allowPasswordPolicyAccess : boolean;
    qualifierLpmenable : boolean;
    enableBloodGlucose: boolean;
    enablePainAd: boolean;
    enablePccSync: boolean;
    enableIntervalMonitoring: boolean;
}


export class FacilityMbConfiguration {
    facilityMbconfigurationId: string;
    facilityId: string;
    orgId: string;
    userName: string;
    password: string;
    vendor: string;
    endPoint: string;
    hostName: string;
    base64Encode: boolean;
    wsUrl: string;
    inboundUsername: string;
    inboundPassword: string;
    adtlastrun: Date;
    adtruninterval: number;
}

export class FacilityIpConfiguration {
    facilityIpconfigurationId: string;
    facilityId: string;
    fromIp: string;
    toIp : string;
    isDeleted: boolean;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/facility-configuration.ts